import { compose as s } from "../../tailwind-buddy-interface.js";
import { textStyles as e } from "../../mixins/typography.js";
const m = s({
  slots: {
    root: ""
  },
  variants: {
    /** Sets the text size. */
    size: {
      inherit: "",
      lgLead: e.lgLead,
      lg: e.lg,
      mdLead: e.mdLead,
      md: e.md,
      smLead: e.smLead,
      sm: e.sm
    }
  },
  defaultVariants: {
    size: "md"
  },
  responsiveVariants: ["size"]
})();
export {
  m as textVariants
};
